import React from "react";
import Button from "../../library/components/Button";
const TableRow = ({
  Button,
  buton_Label,
  anchorTagclassName,
  anchorTag,
  anchorTagName,
  data,
  radio,
  setRadioValue,
  key,
  value,
}) => {
  {
    // console.log(key, "key", value);
  }
  return (
    <tr>
      {anchorTag && (
        <td scope="col">
          <a href="#section0" className={anchorTagclassName}>
            {anchorTagName}
          </a>
        </td>
      )}
      {radio && (
        <td scope="col">
          <input
            type="radio"
            name="key"
            id={key}
            onChange={(e) => setRadioValue(value)}
          />
        </td>
      )}
      {data.map((item, index) => {
        // if (index == 0) {
        //   return <td value={item} key={index} hidden></td>;
        // }
        return (
          <td scope="col" key={index}>
            {item}
          </td>
        );
      })}
      {Button && (
        <td>
          {/* <Button
          onClick={handleChange1}
          btnClass="btn btn-primary"
          value={buton_Label}
        ></Button> */}
          <input className="none" type="button" value={buton_Label}></input>
        </td>
      )}
    </tr>
  );
};

export default TableRow;
